<template>
  <div
    class="text-static-default-low body-1 relative grid gap-x-12 text-left"
    :class="gridTemplateAreasClasses"
  >
    <div
      class="bg-surface-default-low rounded-t-md grid px-12 pt-12 [grid-area:title1]"
    >
      <h2 class="text-static-default-hi heading-2">
        {{ i18n(translations.section1Item1Title) }}
      </h2>
    </div>
    <div
      class="bg-surface-default-low mood-inverse rounded-t-md flex items-center px-12 pt-12 [grid-area:title2]"
    >
      <h2 class="text-static-default-hi heading-2">
        {{ i18n(translations.section1Item2Title) }}
      </h2>
      <IconDiamond class="text-static-default-hi shrink-0" size="24" />
    </div>
    <div class="bg-surface-default-low px-8 py-12 [grid-area:current-text1]">
      <p
        class="bg-surface-brand-mid text-static-default-hi rounded-md body-2 flex h-full items-center px-12 py-8"
      >
        {{ i18n(translations.section1Item1Paragraph1) }}
      </p>
    </div>
    <div class="bg-surface-default-low px-8 pb-12 [grid-area:current-text2]">
      <div
        class="bg-surface-brand-mid text-static-default-hi rounded-md flex h-full flex-col justify-center px-12 py-8"
      >
        <p class="text-static-default-hi body-2">
          {{ i18n(translations.section1Item1Paragraph2) }}
        </p>
        <p class="text-static-default-low caption">
          {{ i18n(translations.section1Item1Paragraph2Description) }}
        </p>
      </div>
    </div>
    <div
      class="bg-surface-default-low rounded-b-md px-8 pb-12 [grid-area:current-text3]"
    >
      <div
        class="bg-surface-brand-mid text-static-default-hi rounded-md flex h-full flex-col justify-center px-12 py-8"
      >
        <p class="text-static-default-hi body-2">
          {{ i18n(translations.section1Item1Paragraph3) }}
        </p>
        <p v-if="isSmartphone" class="text-static-default-low caption">
          {{ i18n(translations.section1Item1Paragraph3Description) }}
        </p>
        <p v-else-if="isLaptop" class="text-static-default-low caption">
          {{ i18n(translations.section1Item1Paragraph3DescriptionLaptop) }}
        </p>
        <p v-else class="text-static-default-low caption">
          {{ i18n(translations.section1Item1Paragraph3DescriptionOthers) }}
        </p>
      </div>
    </div>
    <div
      class="bg-surface-default-low mood-inverse px-8 py-12 [grid-area:new-text1]"
    >
      <p
        class="bg-surface-brand-mid text-static-default-hi rounded-md body-2 flex h-full items-center px-12 py-8"
      >
        {{ i18n(translations.section1Item2Paragraph1, { brand }) }}
      </p>
    </div>
    <div
      class="bg-surface-default-low mood-inverse px-8 pb-12 [grid-area:new-text2]"
    >
      <p
        class="bg-surface-brand-mid text-static-default-hi rounded-md body-2 flex h-full items-center px-12 py-8"
      >
        {{ i18n(translations.section1Item2Paragraph2) }}
      </p>
    </div>
    <div
      class="bg-surface-default-low mood-inverse rounded-b-md px-8 pb-12 [grid-area:new-text3]"
    >
      <div
        class="bg-surface-brand-mid text-static-default-hi rounded-md flex h-full flex-col justify-center px-12 py-8"
      >
        <p class="text-static-default-hi body-2">
          {{ i18n(translations.section1Item2Paragraph3, { brand }) }}
        </p>
        <p v-if="isSmartphone" class="text-static-default-low caption">
          {{ i18n(translations.section1Item2Paragraph3Description) }}
        </p>
        <p v-else class="text-static-default-low caption">
          {{ i18n(translations.section1Item2Paragraph3DescriptionOthers) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { tw } from '@backmarket/utils/string/tw'
import { IconDiamond } from '@ds/icons/IconDiamond'

import translations from './ComparisonArea.translations'

const i18n = useI18n()

const SMARTPHONE_CATEGORY_ID = '2'
const LAPTOP_CATEGORY_IDS = ['11', '216', '109', '9']

const props = defineProps<{
  brand: string
  categoryId: string
}>()

const isSmartphone = computed(() => {
  return props.categoryId === SMARTPHONE_CATEGORY_ID
})

const isLaptop = computed(() => {
  return LAPTOP_CATEGORY_IDS.includes(props.categoryId)
})

// In Tailwind, whitespaces are expressed with `_`
const gridTemplateAreasClasses = tw`[grid-template-areas:'title1_title2''current-text1_new-text1''current-text2_new-text2''current-text3_new-text3'] [grid-auto-columns:1fr]`
</script>
